"use client";

import Hotline from "@/app/(pages)/(dashboard)/profile/support/hotlineSupportModal";
import {
  UniversalStorageConstants,
  UniversalStorageUtils,
} from "@thriwe-2-0/thriwe-ui-utils";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useClientConfigProvider } from "../../config/client-config-provider";
import Constants from "../../constants/constants";
import { EventLabels } from "../../constants/mix-panel-enums";
import AppRoutes from "../../constants/routes";
import { useMixPanel } from "../../context/mixPanelContext";
import FallbackImage from "../FallbackImage";

export default function Footer() {
  const router = useRouter();
  const pathname = usePathname();
  const { config, getImagePath } = useClientConfigProvider();
  const { t } = useTranslation();
  const { trackEvent } = useMixPanel();

  const [isLogin, setIsLogin] = useState<boolean>(true);
  const [showHotlineModal, setShowHotlineModal] = useState<boolean>(false);

  useEffect(() => {
    const auth = !!UniversalStorageUtils.getItem(
      config?.nativeDataSavingType,
      UniversalStorageConstants.AUTH_TOKEN
    );
    setIsLogin(auth);
  }, []);

  const getFooterClass = () => {
    return Constants.delayBookingRoutes.includes(pathname)
      ? "footer-background-delay"
      : "footer-background-normal";
  };

  return (
    <div className={`footer ${getFooterClass()}`}>
      {Hotline({ showHotlineModal, setShowHotlineModal })}

      <div>
        <div className="m-2 d-flex gap-4 flex-column">
          <div className="d-flex justify-content-between flex-md-row flex-column ">
            {!config?.footer.isHideLogo && (
              <div>
                <Image
                  onClick={() => {
                    router.push(AppRoutes.dashboard);
                  }}
                  src={getImagePath("logo.png") ?? ""}
                  alt=""
                  width="150"
                  height="34"
                  className="footer-logo-image"
                />
              </div>
            )}
            {/* {config?.footer?.bottomLinks
              .filter(
                (bottomLink) =>
                  bottomLink.link.filter((link) => {
                    if (link.onLogin) {
                      return link.onLogin == isLogin;
                    } else {
                      return true;
                    }
                  }).length > 0
              )
              .map((footer, index) => {
                return (
                  <div className="footer-item-list" key={index}>
                    <div className="footer-link-header">
                      {t("footer." + footer?.category, footer?.category)}
                    </div>
                    <ul className="footer-link  p-0 list-unstyled">
                      {footer?.link?.map((link, index) => {
                        if (link.onLogin && !isLogin) {
                          return <></>;
                        }
                        return (
                          <li
                            style={{
                              cursor: "pointer",
                              color:
                                pathname == link.routeLink
                                  ? "var(--LightTheme-Primary) !important"
                                  : "",
                            }}
                            onClick={() => {
                              if (link?.routeLink === ``) {
                                setShowHotlineModal(true);
                              } else {
                                router.push(link.routeLink);
                              }
                            }}
                            key={index}
                          >
                            {t("footer." + link?.name, link?.name)}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })} */}
              {(isLogin ? config?.footer?.bottomLinks : config?.footer?.beforeLoginFooterLinks)
              ?.filter(footer =>
                footer.link.some(link =>
                  link.onLogin === undefined || link.onLogin === isLogin
                )
              )
              .map((footer, index) => (
                <div className="footer-item-list" key={index}>
                  <div className="footer-link-header">
                    {t("footer." + footer?.category, footer?.category)}
                  </div>
                  <ul className="footer-link p-0 list-unstyled">
                    {footer.link
                      .filter(link => link.onLogin === undefined || link.onLogin === isLogin)
                      .map((link, idx) => (
                        <li
                          key={idx}
                          style={{
                            cursor: "pointer",
                            color:
                              pathname === link.routeLink ? "var(--LightTheme-Primary) !important" : "",
                          }}
                          onClick={() => {
                            if (link?.routeLink === ``) {
                              setShowHotlineModal(true);
                            } else {
                              router.push(link.routeLink);
                            }
                          }}
                        >
                          {t("footer." + link?.name, link?.name)}
                        </li>
                      ))}
                  </ul>
                </div>
              ))}

            {config?.footer?.showDownloadAppLink && (
              <div className="footer-item-list">
                <div className="footer-link-header">
                  {t("links.downloadOurApp")}
                </div>
                <ul className="footer-link-social  p-0 list-unstyled">
                  <li style={{ cursor: "pointer" }}>
                    <Image
                      onClick={() => {
                        window.open(config?.footer?.playStoreUrl ?? "");
                        trackEvent(EventLabels.CTA_Play_Store, {
                          screen: "Footer",
                        });
                      }}
                      src={"/common-images/play-store-image.png"}
                      alt=""
                      width="150"
                      height="34"
                      className="app-store-img-style"
                    />
                  </li>
                  <li style={{ cursor: "pointer" }}>
                    <Image
                      onClick={() => {
                        window.open(config?.footer?.appStoreUrl ?? "");
                        trackEvent(EventLabels.CTA_App_Store, {
                          screen: "Footer",
                        });
                      }}
                      src={"/common-images/app-store-image.png"}
                      alt=""
                      width="150"
                      height="34"
                      className="app-store-img-style"
                    />
                  </li>

                  {process.env.NEXT_PUBLIC_PROJECT_CODE === `HDFC_BUNDLE` && (
                    <li style={{ cursor: "pointer" }}>
                      <Image
                        onClick={() => {
                          window.open(`https://mycards.hdfcbank.com/`);
                        }}
                        src={getImagePath("hdfc-mycards.png") ?? ""}
                        alt=""
                        width="150"
                        height="34"
                        className="hdfc-footer-cards-img-style"
                      />
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      <hr className="footer-hr" />

      <div
        className={`${"footer-copyright-box"} 
        ${
          ["/golf-detail", "/history-detail"]?.includes(pathname) &&
          "padding-bottom-copyright-text"
        }
        `}
      >
        {config?.footer?.isShowPoweredBy && (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {t("footer.Powered by")}{" "}
            <FallbackImage
              src={getImagePath("thriwe-logo.png")}
              fallbackSrc={""}
              height={24}
              width={82}
              alt={"Logo"}
            />
          </div>
        )}
        <div
          className={`${
            config?.footer?.socialMedia?.length === 0 &&
            !config?.footer?.isShowPoweredBy &&
            "txt_center"
          }`}
        >
          {t("footer.copyRightTextInFooter")}
        </div>

        {(config?.footer.socialMedia ?? []).length > 0 && (
          <div className="footer-social-media-style ">
            {config?.footer.socialMedia?.map((socialMedia, index) => {
              return (
                <div key={index}>
                  <Image
                    onClick={() => {
                      window.open(socialMedia.redirectUrl ?? "");
                    }}
                    src={getImagePath(socialMedia.image) ?? ""}
                    alt=""
                    width="18"
                    height="18"
                    style={{
                      objectFit: "contain",
                      width: "100%",
                    }}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
